import { template as template_f4dd0719be6345a38d26a7f3345aa1a2 } from "@ember/template-compiler";
import Component from '@glimmer/component';
import styles from './insurance-section.module.scss';
import t from 'ember-intl/helpers/t';
export default class SiteDocumentsContactInfoChannelCoverageBanner extends Component {
    get remainingSessionsCount() {
        return this.args.channelClientInfo?.remainingSessionsCount;
    }
    get channelName() {
        return this.args.channelClientInfo?.globalMonarchChannel?.displayName;
    }
    static{
        template_f4dd0719be6345a38d26a7f3345aa1a2(`
    <div class={{styles.component}}>
      <div class="channel-covered">
        <div class="text">
          {{t
            "site.documents.contactInfo.insuranceSection.channelCoverage"
            count=this.remainingSessionsCount
            channelName=this.channelName
          }}
        </div>
      </div>
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
